var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "layout",
    { attrs: { "no-sidebar": true } },
    [
      _c("div", { staticClass: "page-header" }, [
        _c("h1", [_c("small", [_vm._v("Users")])])
      ]),
      _vm._v(" "),
      !_vm.loading
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-lg-3 margin-bottom-3x" }, [
              _c("div", { staticClass: "input-group" }, [
                _c("input", {
                  ref: "search",
                  staticClass: "form-control",
                  attrs: { type: "text", placeholder: "Search for..." },
                  domProps: { value: _vm.searchKey },
                  on: {
                    keyup: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        $event.keyCode !== 13
                      ) {
                        return null
                      }
                      return _vm.search(_vm.$refs.search.value)
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "input-group-btn" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-default",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.search(_vm.$refs.search.value)
                        }
                      }
                    },
                    [_vm._v("Go!")]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "margin-top-2x" }, [
                _c("label", [_vm._v("User type")]),
                _vm._v(" "),
                _c("div", { staticClass: "input-group radio" }, [
                  _c("label", { staticClass: "margin-right-2x" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.type,
                          expression: "type"
                        }
                      ],
                      attrs: { type: "radio", value: "all" },
                      domProps: { checked: _vm._q(_vm.type, "all") },
                      on: {
                        change: [
                          function($event) {
                            _vm.type = "all"
                          },
                          function($event) {
                            return _vm.loadPage(1)
                          }
                        ]
                      }
                    }),
                    _vm._v("\n            All\n          ")
                  ]),
                  _vm._v(" "),
                  _c("label", { staticClass: "margin-right-2x" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.type,
                          expression: "type"
                        }
                      ],
                      attrs: { type: "radio", value: "ims" },
                      domProps: { checked: _vm._q(_vm.type, "ims") },
                      on: {
                        change: [
                          function($event) {
                            _vm.type = "ims"
                          },
                          function($event) {
                            return _vm.loadPage(1)
                          }
                        ]
                      }
                    }),
                    _vm._v("\n            ResLab user\n          ")
                  ]),
                  _vm._v(" "),
                  _c("label", { staticClass: "margin-right-2x" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.type,
                          expression: "type"
                        }
                      ],
                      attrs: { type: "radio", value: "location" },
                      domProps: { checked: _vm._q(_vm.type, "location") },
                      on: {
                        change: [
                          function($event) {
                            _vm.type = "location"
                          },
                          function($event) {
                            return _vm.loadPage(1)
                          }
                        ]
                      }
                    }),
                    _vm._v("\n            Location user\n          ")
                  ]),
                  _vm._v(" "),
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.type,
                          expression: "type"
                        }
                      ],
                      attrs: { type: "radio", value: "channel" },
                      domProps: { checked: _vm._q(_vm.type, "channel") },
                      on: {
                        change: [
                          function($event) {
                            _vm.type = "channel"
                          },
                          function($event) {
                            return _vm.loadPage(1)
                          }
                        ]
                      }
                    }),
                    _vm._v("\n            Channel user\n          ")
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "margin-top-2x" }, [
                _c("label", [_vm._v("2FA status")]),
                _vm._v(" "),
                _c("div", { staticClass: "input-group radio" }, [
                  _c("label", { staticClass: "margin-right-2x" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.twoFaStatus,
                          expression: "twoFaStatus"
                        }
                      ],
                      attrs: { type: "radio", value: "all" },
                      domProps: { checked: _vm._q(_vm.twoFaStatus, "all") },
                      on: {
                        change: [
                          function($event) {
                            _vm.twoFaStatus = "all"
                          },
                          function($event) {
                            return _vm.loadPage(1)
                          }
                        ]
                      }
                    }),
                    _vm._v("\n            All\n          ")
                  ]),
                  _vm._v(" "),
                  _c("label", { staticClass: "margin-right-2x" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.twoFaStatus,
                          expression: "twoFaStatus"
                        }
                      ],
                      attrs: { type: "radio", value: "enabled" },
                      domProps: { checked: _vm._q(_vm.twoFaStatus, "enabled") },
                      on: {
                        change: [
                          function($event) {
                            _vm.twoFaStatus = "enabled"
                          },
                          function($event) {
                            return _vm.loadPage(1)
                          }
                        ]
                      }
                    }),
                    _vm._v("\n            Enabled\n          ")
                  ]),
                  _vm._v(" "),
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.twoFaStatus,
                          expression: "twoFaStatus"
                        }
                      ],
                      attrs: { type: "radio", value: "disabled" },
                      domProps: {
                        checked: _vm._q(_vm.twoFaStatus, "disabled")
                      },
                      on: {
                        change: [
                          function($event) {
                            _vm.twoFaStatus = "disabled"
                          },
                          function($event) {
                            return _vm.loadPage(1)
                          }
                        ]
                      }
                    }),
                    _vm._v("\n            Disabled\n          ")
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "hasPermits",
                    rawName: "v-hasPermits:allow",
                    value: { permits: ["user_create"] },
                    expression: "{permits: ['user_create']}",
                    arg: "allow"
                  }
                ],
                staticClass: "col-lg-9 text-right margin-bottom-3x"
              },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn-default",
                    attrs: {
                      to: {
                        name: "users.new"
                      }
                    }
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-plus",
                      attrs: { "aria-hidden": "true" }
                    }),
                    _vm._v("\n        New User\n      ")
                  ]
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.loading
        ? _c("div", { staticClass: "text-center" }, [
            _c("i", { staticClass: "fa fa-spinner fa-spin fa-3x fa-fw" })
          ])
        : _c(
            "div",
            [
              _c("div", { staticClass: "table-responsive" }, [
                _c("table", { staticClass: "table table-striped" }, [
                  _c("thead", [
                    _c("tr", [
                      _c("th", [_vm._v("Name")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("Email")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("Phone")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("2FA Action")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("2FA Status")]),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          directives: [
                            {
                              name: "hasPermits",
                              rawName: "v-hasPermits:allow",
                              value: ["super_admin"],
                              expression: "['super_admin']",
                              arg: "allow"
                            }
                          ]
                        },
                        [_vm._v("Reset 2FA")]
                      ),
                      _vm._v(" "),
                      _c("th", [_vm._v("Edit")]),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          directives: [
                            {
                              name: "hasPermits",
                              rawName: "v-hasPermits:allow",
                              value: { permits: ["user_delete"] },
                              expression: "{permits: ['user_delete']}",
                              arg: "allow"
                            }
                          ],
                          staticClass: "text-right"
                        },
                        [_vm._v("Remove")]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.users.data, function(item, i) {
                      return _c("tr", [
                        _c("td", [
                          _vm._v(
                            "\n              " +
                              _vm._s(item.name) +
                              "\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n              " +
                              _vm._s(item.email) +
                              "\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm._f("phone")(item.phone)) +
                              "\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(_vm.twoFactorActionLabel(item.two_fa_action))
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm.twoFactorEnabled(item)
                            ? _c("i", {
                                staticClass: "fa fa-check text-success",
                                attrs: {
                                  "aria-hidden": "true",
                                  title: "Enabled"
                                }
                              })
                            : _c("i", {
                                staticClass: "fa fa-times text-danger",
                                attrs: {
                                  "aria-hidden": "true",
                                  title: "Disabled"
                                }
                              })
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            directives: [
                              {
                                name: "hasPermits",
                                rawName: "v-hasPermits:allow",
                                value: ["super_admin"],
                                expression: "['super_admin']",
                                arg: "allow"
                              }
                            ]
                          },
                          [
                            _vm.twoFaResetLoadings[item.id]
                              ? _c("span", [
                                  _c("i", {
                                    staticClass: "fa fa-spinner fa-spin fa-fw"
                                  })
                                ])
                              : _vm.twoFactorEnabled(item)
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-xs btn-warning",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.reset2fa(item)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Reset 2FA\n              "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: {
                                    name: "users.edit",
                                    params: { id: item.id }
                                  }
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-pencil",
                                  attrs: { "aria-hidden": "true" }
                                })
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            directives: [
                              {
                                name: "hasPermits",
                                rawName: "v-hasPermits:allow",
                                value: { permits: ["user_delete"] },
                                expression: "{permits: ['user_delete']}",
                                arg: "allow"
                              }
                            ],
                            staticClass: "text-right"
                          },
                          [
                            _vm.users_loadings[item.id]
                              ? _c("span", [
                                  _c("i", {
                                    staticClass: "fa fa-spinner fa-spin fa-fw"
                                  })
                                ])
                              : _c(
                                  "a",
                                  {
                                    staticClass: "text-danger",
                                    attrs: { href: "#" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.removeUser(item)
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-times",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  ]
                                )
                          ]
                        )
                      ])
                    }),
                    0
                  )
                ])
              ]),
              _vm._v(" "),
              _c("pagination", {
                attrs: { "pages-number": _vm.users.last_page },
                on: {
                  pageChanged: function(page) {
                    return _vm.loadPage(page)
                  }
                }
              })
            ],
            1
          ),
      _vm._v(" "),
      _c("confirm", { ref: "deleteConfirm", attrs: { type: "danger" } }),
      _vm._v(" "),
      _c("confirm", { ref: "reset2faConfirm", attrs: { type: "warning" } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5fa16246", { render: render, staticRenderFns: staticRenderFns })
  }
}